import { z } from 'zod';
import { accountSchema } from './account.js';

export const passwordSchema = z.string().min(12, 'Password must be at least 12 characters');

export const loginRequestSchema = z.object({
  pseudo: z.string().min(2).max(32),
  password: z.string().min(1),
});
export type LoginRequest = z.infer<typeof loginRequestSchema>;

export const discordAuthErrorCodeSchema = z.enum([
  'DISCORD_ACCOUNT_UNVERIFIED',
  'DISCORD_MEMBERSHIP_PENDING',
  'DISCORD_ACCESS_DENIED',
  'DISCORD_OAUTH_FAILED',
  'OAUTH_STATE_INVALID',
  'NOT_IN_GUILD',
  'ROLE_NOT_ALLOWED',
  'DISCORD_ACCOUNT_BANNED',
]);
export type DiscordAuthErrorCode = z.infer<typeof discordAuthErrorCodeSchema>;

export const registerRequestSchema = z.object({
  pseudo: z
    .string()
    .min(2)
    .max(32)
    .regex(/^[a-zA-Z0-9_-]+$/, 'Pseudo: only letters, digits, underscore, dash'),
  email: z.string().email().optional(),
  password: passwordSchema,
});
export type RegisterRequest = z.infer<typeof registerRequestSchema>;

export const sessionResponseSchema = z.object({
  account: accountSchema,
  csrfToken: z.string(),
});
export type SessionResponse = z.infer<typeof sessionResponseSchema>;
